import NLUDataHeader from '../NLUDataHeader/NLUDataHeader'

import NLUStatsContent from './NLUStatsContent/NLUStatsContent'

import styles from './nlu-stats.module.scss'

function NLUStats() {
    return (
        <div className={styles.stats}>
            <NLUDataHeader />
            <main className={styles.stats__main}>
                <NLUStatsContent />
            </main>
        </div>
    )
}

export default NLUStats
